module.exports = __webpack_public_path__ + "static/media/galeryVinyl3.157bfbaa.jpg";